export default __webpack_public_path__ + "static/media/22t.98fea0e7.jpg";